import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'
import { useTranslation } from 'react-i18next'

interface TemplateDeleteConfirmDialogProps {
  open: boolean
  name: string | undefined
  isDeleting: boolean
  onConfirm: () => void
  onCancel: () => void
}

export const TemplateDeleteConfirmDialog = ({
  open,
  name,
  isDeleting,
  onConfirm,
  onCancel,
}: TemplateDeleteConfirmDialogProps) => {
  const { t } = useTranslation('@cibo/programs/TemplateEditorModal')
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>{t('deleteConfirmTitle')}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t('deleteConfirmMessage', { name })}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>{t('cancel')}</Button>
        <Button color="error" variant="contained" loading={isDeleting} onClick={onConfirm}>
          {t('delete')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
